/* src/app/shared/protocolo-arquivos/protocolo-listagem.component.scss */
/*# sourceMappingURL=protocolo-listagem.component.css.map */
